/* eslint-disable */
import React from "react";
import { useTranslation } from "react-i18next";

export default function Table({ Accounts = [], loading, typeData }) {
  const { t, i18n } = useTranslation();
  const dir = i18n.dir(); // "rtl" or "ltr"

  return (
    <div
      className="max-w-screen-xl mx-auto px-4 md:px-8"
      dir={dir}
    >
      <div className="mt-8 shadow-sm border dark:!border-[#3c3a3d] rounded-lg overflow-x-auto">
        <table className="w-full table-auto text-sm px-4 text-gray-800">
          <thead className="bg-gray-50 dark:!bg-[#141414] text-gray-600 font-medium border-b dark:!border-[#3c3a3d] px-4">
            <tr className={dir === "rtl" ? "text-right dark:text-gray-200" : "text-left dark:text-gray-200 "}>
              <th className="py-3 px-4">{t("name")}</th>
              <th className="py-3">{t("email")}</th>
              <th className="py-3">{t("phone")}</th>
              {typeData === "paid" && <th className="py-3">{t("points")}</th>}
            </tr>
          </thead>
          <tbody className={`divide-y px-4 ${dir === "rtl" ? "text-right" : "text-left"}`}>
            {loading ? (
              <tr className="dark:text-gray-300">
                <td
                  colSpan={typeData === "paid" ? "4" : "3"}
                  className="text-center py-4"
                >
                  {t("download...")}
                </td>
              </tr>
            ) : Accounts?.length > 0 ? (
              Accounts.map((account) => (
                <tr key={account.id} className="dark:text-gray-300">
                  <td className="py-4 whitespace-nowrap px-4">
                    {account.name || t("dontexist")}
                  </td>
                  <td className="py-4 whitespace-nowrap">
                    {account.email || t("dontexist")}
                  </td>
                  <td className="py-4 whitespace-nowrap">
                    {account.phone || t("dontexist")}
                  </td>
                  {typeData === "paid" && (
                    <td className="py-4 whitespace-nowrap">
                      {account.subscription ? account.subscription * 10 : t("dontexist")}
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr className="dark:text-gray-300">
                <td
                  colSpan={typeData === "paid" ? "4" : "3"}
                  className="text-center py-4"
                >
                  {t("nodata")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
